import React from 'react'
import {findDOMNode} from "react-dom"
import RenderComponentProto from '../../render-component-proto'

import Popover from '../../../../gd-components/gd-popover/popover-v2'
import PopoverPosition from '../../../../gd-components/gd-popover/popover-position'
import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll'

type Props = {
    id                   : string
    renderMode           : 'list' | 'view' | 'edit' | 'form-new'
    value?               : any
    canEdit?             : boolean
    className?           : string
    onChange?            : callback
    onCustomFieldEdited? : callback
}

type State = {
    value       : any
    showPopover : boolean
}

export default class ListComponentProto extends RenderComponentProto<Props, State> {

    static defaultProps = {
        canEdit: false,
    }

    state:State = {
        value: this.props.value,
        showPopover: false,
    }

    showPopover = () => {
        if (!this.state.showPopover) {
            this.setState({showPopover: true})
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({showPopover: false})
        }
    }

    onOptionClick(value:any) {
        this.setState({ value: value }, () => {
            if (this.props.onChange) {
                this.props.onChange(value)
            }
            this.hidePopover()
        })
    }

    onManageCustomField = () => {
        this.hidePopover()

        const customField = gd.session.customFields.get(this.props.id)

        gd.modals.customField.editCustomField({
            title: customField.name,
            // organizationId: customField.companyId,
            customField: customField,
            callback: this.props.onCustomFieldEdited
        })
    }

    renderOptionItems(items:any[]) {
        let content = null

        if (items) {
            content = items.map(item => {
                const classes = Classes('option', {['pill']: !!item.color})

                const valueClasses = !!item.color ?
                    Classes('ui5-pill-22', 'color-pale', 'w200', {
                        ['gd-c-bgp-'+item.color]: !!item.color,
                        'no-color': !item.color,
                        bold: this.state.value === item.id
                    })
                    :
                    Classes('label', {
                        bold: this.state.value === item.id
                    })

                return (
                    <div key={item.id} className={classes} onClick={this.onOptionClick.bind(this, item.id)}>
                        <div className={valueClasses}>{item.value}</div>
                    </div>
                )
            })
        }

        return content
    }

    renderPopover() {
        if (!this.state.showPopover) {
            return false
        }
        const options = this.getOptions()

        return (
            <Popover className="field-list-popover-container"
                     popoverClass="gd-field-list-popover"
                     position={PopoverPosition.top()}
                     getTargetFunc={()=>findDOMNode(this)}
                     onClickOutside={()=>{this.hidePopover()}}>

                <VScroll className="field-list-block" scrollVisibility="auto">
                    <div className="ui5-popover-menu with-help">
                        {this.renderOptionItems(options)}
                        <div className="help">
                            <div className="ui5-link-small manage-action" onClick={this.onManageCustomField}>Edit options</div>
                        </div>
                    </div>
                </VScroll>
            </Popover>
        )
    }

    getOptions() {
        const cf = gd.session.customFields.get(this.props.id)
        return [{
            id: null,
            value: 'None',
        }].concat(cf.params.listItems)
    }

    render() {
        const value = this.state.value
        const classes = Classes('gd-field-list', this.props.renderMode, this.props.className, {
            'disabled': this.props.canEdit === false,
            'not-set': !value,
            'opened-popover' : this.state.showPopover,
        })

        const options = this.getOptions()
        const option:any = value ? _.find(options, o => o.id === value) : null
        const label = option ? option.value : 'Select'
        const colorClass = option && !_.isNil(option.color) ? "ui5-pale-bg gd-c-bgp-" + option.color : 'no-background'

        const pillClasses = Classes("field-holder", "ui5-pill-22", "no-border", colorClass)

        return (
            <div className={classes} onClick={this.props.canEdit ? this.showPopover : null}>
                <div className={pillClasses}>{label}</div>
                {this.renderPopover()}
            </div>
        )
    }
}
